import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            params.jobTypeCategoryId = 2;
            const response = await axios.get('/Flow/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            params.jobTypeCategoryId = 2;
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/Flow/updateRow', params);
            }
            else
            {
                response = await axios.post('/Flow/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async copyFlow(params)
    {
        try
        {
            const response = await axios.post('/Flow/copyFlow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Flow/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async printToPdf(params)
    {
        window.open(`/Flow/printToPdf?id=${params.flowId}`);
    },
};
